import * as Sentry from '@sentry/react';

/**
 * Lightweight logging facade. Delegates to Sentry today — swap the
 * implementation here if the error-tracking provider changes, without
 * touching call-sites across the codebase.
 */
class Logger {
  warn(message: string): void {
    Sentry.captureMessage(message, 'warning');
  }

  error(messageOrError: string | Error): void {
    if (messageOrError instanceof Error) {
      Sentry.captureException(messageOrError);
    } else {
      Sentry.captureMessage(messageOrError, 'error');
    }
  }
}

export const logger = new Logger();
